import { net_api_url } from 'components/Store';
import axios from 'axios';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
const getCurrentTeam = async (getAccessToken, source) => {
  try {
    let token = await getAccessToken();
    let currentTeam = await axios.get(`${net_api_url}/api/team/get-current-team`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal: source?.signal,
    });
    let currentTeamInformation = currentTeam.data;
    return currentTeamInformation;
  } catch (error) {
    if (error.name === 'CanceledError') {
      console.error(error?.config?.signal?.reason);
    } else {
      console.error(error);
    }
  }
};

const useGetCurrentTeam = () => {
  const { generalApiCall } = useGeneralApiCall();

  const currentTeamCall = async ({ source }) => {
    try {
      return await generalApiCall({
        method: 'get',
        pathname: '/api/team/get-current-team',
        needsAuthentication: true,
        source,
        returnCompleteRequest: true,
      });
    } catch (error) {}
  };

  return { currentTeamCall };
};

export { useGetCurrentTeam };
export default getCurrentTeam;
